import { render } from "./WelcomePoint.vue?vue&type=template&id=08986b0c&scoped=true"
import script from "./WelcomePoint.vue?vue&type=script&lang=js"
export * from "./WelcomePoint.vue?vue&type=script&lang=js"

import "./WelcomePoint.vue?vue&type=style&index=0&id=08986b0c&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08986b0c"]])

export default __exports__